export function formatLastSeen(value: string | null): string {
  if (!value) return 'Posizione non impostata';
  const date = new Date(value);
  const deltaMinutes = Math.floor((Date.now() - date.getTime()) / 60_000);
  if (deltaMinutes < 1) return 'Adesso';
  if (deltaMinutes < 60) return `${deltaMinutes} min fa`;
  if (deltaMinutes < 24 * 60) return date.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  return date.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });
}

export function formatCountdown(target: string, now = Date.now()): string {
  const remainingSeconds = Math.max(0, Math.floor((new Date(target).getTime() - now) / 1000));
  const days = Math.floor(remainingSeconds / 86_400);
  const hours = Math.floor((remainingSeconds % 86_400) / 3_600);
  const minutes = Math.floor((remainingSeconds % 3_600) / 60);
  const seconds = remainingSeconds % 60;
  const clock = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
  return days > 0 ? `${days}g ${clock}` : clock;
}

export function toSlug(value: string): string {
  const slug = value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  return `${slug || 'luogo'}-${Date.now().toString(36)}`;
}
